import React, { Fragment, useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import TabContext from '@mui/lab/TabContext'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import { Box, Button, Drawer, List, ListItem, Divider, ListItemText, ListItemButton, ListItemIcon, Tab, Typography } from '@mui/material'
import { useLocation } from 'react-router-dom'
import GeneradorForm from '../components/tabForms/GeneradorForm'
import CuotasForm from '../components/tabForms/CuotasForm'
import LineaNegocioForm from '../components/tabForms/LineaNegocioForm'
import CustomerForm from '../components/tabForms/CustomerForm'
import InterviewForm from '../components/tabForms/InterviewForm'
import ValidaForm from '../components/tabForms/ValidaForm'
import { BranchService } from '../services/branchService'
import { setTab, setCustomer, setInterview, setCustomerFormatted, setContractFull, setSucursales, setCuotas } from '../Redux/TabDucks'
import { InterviewService } from '../services/interviewService'
import { BookCheck, CircleFadingArrowUp, CircleX, FileStack, FolderClock, Grid2x2Plus, InboxIcon, MailIcon, PenLine } from 'lucide-react'
import Cookies from 'universal-cookie'
import { useNavigate } from 'react-router-dom';
import { LogoutUser } from '../Redux/UsersDucks'
import Actualizar from '../components/Acciones/Actualizar'
//import Unificar from '../components/Acciones/Unificar'
import Estrategia from '../components/Acciones/Estrategia'
import Finiquitar from '../components/Acciones/Finiquitar'
import Cancelar from '../components/Acciones/Cancelar'
//import UnificacionCuotas from '../components/Acciones/UnificacionCuotas'




const TabularPageV2 = () => {
  const dispatch = useDispatch()
  const location = useLocation()
  const navigate = useNavigate()

  const [disabledEntrevista, setDisabledEntrevista] = useState(false)
  const [disabledNegocio, setDisabledNegocio] = useState(false)
  const [disabledCuotas, setDisabledCuotas] = useState(false)
  const [disabledContrato, setDisabledContrato] = useState(false)
  const [disabledValidacion, setDisabledValidacion] = useState(false)
  const [bloquearAcciones, setBloquearAcciones] = useState(false);
  const [inyectado, setInyectado] = useState(false);
  const [keyRefresh, setKeyRefresh] = useState(0);

  const [showAcciones, setShowAcciones] = useState(false)
  const [hiddenTabs, setHiddenTabs] = useState({ tab: false, finiquitar: true, unificacion_cuotas:true, actualizar: true, unificar: true, estrategia: true, cancelar: true, });
  const value = useSelector((store) => store.tab.tab)
  const customer = useSelector((store) => store.tab.customer)
  const DataInterview = useSelector((store) => store.tab.interview)
  const general = useSelector((store) => store.general)
  const _TAB = useSelector((store) => store.tab)

  const reiniciar = () => {
    setKeyRefresh(prev => prev + 1); // cambia la key y React desmonta + vuelve a montar el componente
  };
  
  const handleChangeIndex = (event, newValue) => {
    if (newValue == "acciones")
      setShowAcciones(true)
    else
      dispatch(setTab(newValue))
  }

  const fetchInterview = async (customer, _clickTab, customerInterviewId) => {
    var interview = null
    if (customerInterviewId)
      interview = await InterviewService.getCustomerInterviewId(customerInterviewId)
    else if (DataInterview && DataInterview.id)
      interview = await InterviewService.getCustomerInterviewId(DataInterview.id)
    // Esta logica no sirve, si ahora estamos trabajando en base a una linea de negocio
    // else if (customer && customer.id)
    //   interview = await InterviewService.getInterviewByHubspotId(customer.id)
    else
      return

    console.log(interview)

    if (interview != null) {
      var tab = _clickTab ?? interview.etapaId

      /*
      // cruce causas con tribunales
      const filteredTrib = general.tribunalesext.filter(t => t.codigoTribunalCivil !== null)

      const mappedData = interview.causas.map(element => {
        const tribunalMatch = filteredTrib.find(
          t => t.codigoTribunalCivil === element.codTribunal
        );
        return {
          ...element,
          codTribunal: tribunalMatch ? tribunalMatch.id : element.codTribunal
        };
      });*/


      dispatch(setInterview({ id: interview.id, content: interview.hojaAtencion, causas: interview.causas, fecha: interview.createAt, origen: interview.origen, dealHubspotId: interview.dealHubspotId, etapaId: interview.etapaId, interview2:interview }))

      if (value == 0 || value == "0")
        dispatch(setTab(tab.toString()))

      if (interview.customer)
        dispatch(setCustomerFormatted(interview.customer))

      if (interview.contract)
        dispatch(setContractFull(interview.contract))

      if (interview.cuotas)
        dispatch(setCuotas(interview.cuotas))

      const data = await BranchService.getAllBrach()
      dispatch(setSucursales(data))
    }
    else {
      // si no tiene generar nueva interview vacia  
      interview = await InterviewService.startInterview(customer.id)
      console.log(interview)
      dispatch(setInterview({ id: interview.id }))
    }
  }

  // useEffect(() => {
  //   const { tab, customer, customerInterviewId, starInterview } = location.state || {}
    
  //   if (customerInterviewId)
  //     fetchInterview(null, null, customerInterviewId)

  //   if (tab)
  //     dispatch(setTab(tab))
  //   if (customer)
  //     dispatch(setCustomer(customer))
  //   fetchInterview(customer, null, null)
  // }, [location.state, dispatch])


  useEffect(() => {
  const { tab, customer, customerInterviewId } = location.state || {};
  const savedInterviewId = sessionStorage.getItem("customerInterviewId");

  const interviewId =
    customerInterviewId || 
    DataInterview?.id || 
    _TAB?.interview?.id || 
    savedInterviewId || 
    null;

  if (interviewId) sessionStorage.setItem("customerInterviewId", interviewId);

  if (tab) dispatch(setTab(tab));
  if (customer) dispatch(setCustomer(customer));

  if (interviewId) {
    fetchInterview(null, null, interviewId);
  } else if (customer?.id) {
    fetchInterview(customer, null, null);
  }

}, [location.state, DataInterview?.id, _TAB?.interview?.id, dispatch]);


  useEffect(() => {
    fetchInterview(customer, value, null)
  }, [value])

  const toggleDrawer = (newOpen) => () => {
    setShowAcciones(newOpen)
  }

  const setHide = () => {
    setHiddenTabs({
      tab: false,
      finiquitar: true,
      actualizar: true,
      unificacion_cuotas: true,
      estrategia: true,
      cancelar: true
    })
  }

  const onclickAcciones = (accion) => () => {
    const cookies = new Cookies();
    if (cookies) {
      var exp = cookies.get('expirationTime');
      var expirationTime = null;

      if (typeof exp === "number") {
        expirationTime = exp * 1000;
      } else if (typeof exp === "string") {
        expirationTime = new Date(exp).getTime();
      }

      if (expirationTime) {
        const isExpired = Date.now() >= expirationTime;
        if (isExpired) {
          dispatch(LogoutUser())
          navigate("/")
          return
          // aquí podrías redirigir o eliminar la cookie
        }
      }
      if (cookies.get('identifier') == null) {
        dispatch(LogoutUser())
        navigate("/")
        return
      }
    }

    setHiddenTabs({
      tab: true,
      finiquitar: true,
      actualizar: true,
      unificacion_cuotas: true,
      unificar: true,
      estrategia: true,
      cancelar: true,
      [accion.toLowerCase()]: false, // activa solo el seleccionado
    });
  }

  const DrawerList = (
    <Box sx={{ width: 250 }} role="presentation" onClick={toggleDrawer(false)}>
      <Typography variant="h6" className='ps-4 p-2' sx={{ flexGrow: 1, display: { xs: 'none', sm: 'block' } }} >
        Acciones
      </Typography>
      <List>
        <ListItem disablePadding>
          <ListItemButton onClick={onclickAcciones("cancelar")} disabled={bloquearAcciones || inyectado}>
            <ListItemIcon> <CircleX /> </ListItemIcon>
            <ListItemText primary={"Cancelar"} />
          </ListItemButton>
        </ListItem>

        <ListItem disablePadding>
          <ListItemButton onClick={onclickAcciones("finiquitar")} disabled={disabledValidacion /*|| bloquearAcciones*/ || !inyectado}>
            <ListItemIcon> <CircleX /> </ListItemIcon>
            <ListItemText primary={"Finiquitar"} />
          </ListItemButton>
        </ListItem>
{/*
        <ListItem disablePadding 
        //disabled={disabledValidacion}
        >
          <ListItemButton onClick={onclickAcciones("unificacion_cuotas")} >
            <ListItemIcon> <Grid2x2Plus /> </ListItemIcon>
            <ListItemText primary={"Unificar"} />
          </ListItemButton>
        </ListItem>
*/}

        <ListItem disablePadding hidden>
          <ListItemButton onClick={onclickAcciones("actualizar")} >
            <ListItemIcon> <PenLine /> </ListItemIcon>
            <ListItemText primary={"Actualizar"} />
          </ListItemButton>
        </ListItem>


        <ListItem disablePadding hidden>
          <ListItemButton onClick={onclickAcciones("estrategia")} >
            <ListItemIcon> <CircleFadingArrowUp /> </ListItemIcon>
            <ListItemText primary={"Cambio de Estrategia"} />
          </ListItemButton>
        </ListItem>

      </List>
      <Divider />
      <Typography variant="h6" className='ps-4 p-2' sx={{ flexGrow: 1, display: { xs: 'none', sm: 'block' } }}>
        Otros
      </Typography>

      <List>
        <ListItem disablePadding hidden>
          <ListItemButton>
            <ListItemIcon> <FileStack /> </ListItemIcon>
            <ListItemText onClick={onclickAcciones("Cronologia")} primary={"Cronologia"} />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding hidden>
          <ListItemButton>
            <ListItemIcon> <BookCheck /> </ListItemIcon>
            <ListItemText onClick={onclickAcciones("Legado")} primary={"Contratos Anteriores"} />
          </ListItemButton>
        </ListItem>
      </List>
    </Box>
  )


  useEffect(() => {
    if (_TAB.interview?.etapaId != null) {
      var _etapa = _TAB.interview.etapaId
      setDisabledEntrevista(_etapa >= 1 ? false : true)
      setDisabledNegocio(_etapa >= 2 ? false : true)
      setDisabledCuotas(_etapa >= 3 ? false : true)
      setDisabledContrato(_etapa >= 4 ? false : true)
      setDisabledValidacion(_etapa >= 5 ? false : true)
    }
  }, [_TAB])
  

  useEffect(() => {
    if (_TAB.contractFull?.cancel == true) {
      setBloquearAcciones(true)
    }
    if (_TAB.contractFull?.finiquitado == true) {
      setBloquearAcciones(true)
    }
    if (_TAB.contractFull?.mailSends == true) {
      setInyectado(true)
    }
  }, [_TAB])

  return (
    <Fragment>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }} hidden={hiddenTabs.tab}>
        <TabContext value={value}>
          <TabList onChange={handleChangeIndex} aria-label="lab API tabs example">
            <Tab label="Hoja de Atención" value="0" />
            <Tab label="Entrevista" value="1" disabled={disabledEntrevista} />
            <Tab label="Servicios" value="2" disabled={disabledNegocio} />
            <Tab label="Cuotas" value="3" disabled={disabledCuotas} />
            <Tab label="Contrato" value="4" disabled={disabledContrato} />
            <Tab label="Validación" value="5" disabled={disabledValidacion} />
            <Box sx={{ flexGrow: 1 }} />
            <Tab label="Acciones" value="acciones" />
          </TabList>
          <TabPanel value="0"> <InterviewForm /> </TabPanel>
          <TabPanel value="1"> <CustomerForm /> </TabPanel>
          <TabPanel value="2"> <LineaNegocioForm /> </TabPanel>
          <TabPanel value="3"> <CuotasForm /> </TabPanel>
          <TabPanel value="4"> <GeneradorForm key={keyRefresh} reiniciar={reiniciar}/> </TabPanel>
          <TabPanel value="5"> <ValidaForm /> </TabPanel>
        </TabContext>
      </Box>

      <Drawer anchor='right' open={showAcciones} onClose={toggleDrawer(false)}> {DrawerList} </Drawer>

      {hiddenTabs.cancelar ? null : <Cancelar setHide={setHide}/>}
      {hiddenTabs.finiquitar ? null : <Finiquitar setHide={setHide}/>}
      {/*hiddenTabs.unificacion_cuotas ? null : <UnificacionCuotas setHide={setHide}/>*/}
      {/*hiddenTabs.unificar ? null : <Unificar setHide={setHide} />*/}
      {/*hiddenTabs.actualizar ? null : <Actualizar setHide={setHide} />*/}
      {/*hiddenTabs.estrategia ? null : <Estrategia setHide={setHide} />*/}

    </Fragment>
  )
}

export default TabularPageV2